import BaseService from "../BaseService";
import _ from "lodash";

class ProductVariantService extends BaseService {
    update = async ({ id, options, variants }) => {
        var data = await this._api.post("/product_variant/update", { id, options, variants });
        return data;
    };

    updatePriceList = async ({ variants }) => {
        var data = await this._api.post("/product_variant/update_pricelist", {  variants });
        return data;
    };


    list = async ({ info, ids, customer_id, fields } = {}) => {
        var data = await this._api.post("/product_variant/list", { info, ids, customer_id, fields });
        return data;
    };

    updateInventory = async ({ id, on_hand_quantity, reserved_quantity, low_stock_threshold, track_inventory, allow_backorder, warehouse_id, note }) => {
        var data = await this._api.post("/product_variant/update_inventory", {
            id,
            on_hand_quantity,
            reserved_quantity,
            low_stock_threshold,
            track_inventory,
            allow_backorder,
            warehouse_id,
            note
        });
        return data;
    };

    bulkUpdateInventory = async ({ variants = [], note } = {}) => {
        var data = await this._api.post("/product_variant/bulk_update_inventory", { variants, note });
        return data;
    };


  



}
export default ProductVariantService;
